import axios from '../../localAxios';
import { MoveTask } from '../MoveTask';
import { moveURL } from '../url';

export interface DeleteQuizFolderParam {
  folderIds?: number[];
  quizIds?: number[];
}

export type DeleteQuizFolderResponse = Record<string, never>;

export async function deleteQuizFolder({
  folderIds = [],
  quizIds = [],
}: DeleteQuizFolderParam) {
  const url = moveURL();
  const response = await axios.put<DeleteQuizFolderResponse>(url.href, {
    folderIds: folderIds,
    parentId: null,
    quizIds: quizIds,
    task: MoveTask.DELETE,
  });
  return response.data;
}
